import { render, staticRenderFns } from "./UpdateConfigType.vue?vue&type=template&id=21d1a372&scoped=true&"
import script from "./UpdateConfigType.vue?vue&type=script&lang=js&"
export * from "./UpdateConfigType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d1a372",
  null
  
)

export default component.exports